import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
export var MatureStrictBlockedFullView = function (props) {
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ iconType: "hidden", title: t([
            "deviationview.blocked.mature.strict",
            'deviationview.blocked.default',
        ]), text: t("deviationview.blocked.mature.strict.text", {
            defaultValue: null,
        }) }, props)));
};
export default MatureStrictBlockedFullView;
//# sourceMappingURL=MatureStrictBlocked.js.map